var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurveyIconCamera = function SvgSurveyIconCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#338CFF",
    d: "M1.326 12.777c0-1.078 1.12-2.03 2.834-2.612a5.411 5.411 0 1 1 7.82-.01c1.733.58 2.864 1.538 2.864 2.622 0 1.771-3.026 3.207-6.758 3.207s-6.76-1.435-6.76-3.207m3.681-6.35a3.058 3.058 0 1 0 6.117 0 3.058 3.058 0 0 0-6.117 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C3A",
    d: "M8.054 4.7a1.703 1.703 0 0 1 1.645 1.756A1.703 1.703 0 0 1 8.054 8.21a1.703 1.703 0 0 1-1.646-1.755A1.703 1.703 0 0 1 8.054 4.7"
  })));
};
export default SvgSurveyIconCamera;